<template>
  <GestionEventosPendientesTecnico />
</template>
<script>
import GestionEventosPendientesTecnico from "./components/GestionEventosPendientesTecnico.vue";
export default {
  name: "EventosPendientesTecnico",
  components: { GestionEventosPendientesTecnico }
};
</script>